import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';

var _createNamespace = createNamespace('tab'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('Tab'),
    data: function data() {
        return {
            inited: false
        };
    },
    props: {
        name: [Number, String],
        title: String,
        titleStyle: null,
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedName: function computedName() {
            return this.name !== undefined ? this.name : this.index;
        },
        isActive: function isActive() {
            return !this.disabled && this.computedName === this.$parent.currentName;
        },
        index: function index() {
            var _a;

            return (_a = this.$parent.children) === null || _a === void 0 ? void 0 : _a.indexOf(this);
        }
    },
    mounted: function mounted() {
        this.bindRelation();
    },
    beforeDestroy: function beforeDestroy() {
        this.unbindRelation();
    },
    watch: {
        '$parent.currentIndex': function $parentCurrentIndex() {
            this.inited = this.inited || this.isActive;
        }
    },
    methods: {
        unbindRelation: function unbindRelation() {
            var _this = this;

            var _a;

            if (this.$parent && Array.isArray(this.$parent.children)) {
                this.$parent.children =
                    (_a = this.$parent.children) === null || _a === void 0
                        ? void 0
                        : _a.filter(function(item) {
                              return item !== _this;
                          });
            }
        },
        bindRelation: function bindRelation() {
            var _a;

            if (
                !this.$parent ||
                ((_a = this.$parent.children) === null || _a === void 0 ? void 0 : _a.indexOf(this)) !== -1
            ) {
                return;
            }

            this.$parent.children = [].concat(this.$parent.children, [this]);
        }
    },
    render: function render() {
        var h = arguments[0];

        if (this.$parent.animated) {
            return h(
                'div',
                {
                    class: b('tab-wrapper', {
                        inactive: !this.isActive
                    })
                },
                [
                    h(
                        'div',
                        {
                            class: b()
                        },
                        [this.inited ? this.$slots.default : '']
                    )
                ]
            );
        }

        return h(
            'div',
            {
                class: b(),
                directives: [
                    {
                        name: 'show',
                        value: this.isActive
                    }
                ]
            },
            [this.inited ? this.$slots.default : '']
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
